// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MFPe","type":"styles_type__3pVnB","choices":"styles_choices__3ASSa"};